<div class="campaign-terms">
  <campaign-term
  *ngFor="let term of selectableCampaignTerms"
  [campaignTerm]="term"
  (selectEvent)="selectChange($event)"
  (deleteEvent)="deleteTerm($event)"
  (editEvent)="modifyCustomTerm($event)"
  (ngModelChange)="onModelChanged($event)"
  [isReadOnly]="isReadOnly"
  ></campaign-term>
  <div class="d-flex flex-g1 justify-content-end buttons">
    <button class="button green"
            actionByLevels="Basic brief"
            [wallName]="'Campaign Disabled'"
            (afterChecking)="modifyCustomTerm(null)"
            [disabled]="isReadOnly">
      {{'common.btn.add_customer_term' | translate}}
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/selectable-campaign-terms/selectable-campaign-terms.component.html